import { SVGProps } from '@components/Icon/types';

export const Assessment = ({
  fill = '#000',
  size = 24,
  ...props
}: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(4, 2)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 2.95073C16 1.6892 14.9199 0.673161 13.5804 0.673161H11.9329C11.6566 0.269361 11.1754 0 10.6322 0H5.3679C4.8227 0 4.33988 0.27139 4.06407 0.677721L2.33236 0.674602C1.03343 0.717605 0 1.71673 0 2.95073V17.7224C0 18.984 1.08008 20 2.41955 20H13.5805C14.9199 20 16 18.984 16 17.7224V2.95073ZM10.8669 2.74461C10.9969 2.65859 10.9969 2.55308 10.9969 2.55308V1.45963C10.9969 1.45963 10.9969 1.35108 10.9177 1.28728C10.7776 1.17432 10.6322 1.19845 10.6322 1.19845H5.3679C5.3679 1.19845 5.26326 1.18208 5.13324 1.2681C5.00322 1.35413 5.00321 1.45963 5.00321 1.45963V2.55308C5.00321 2.55308 5.00321 2.66163 5.08236 2.72543C5.2225 2.83839 5.36789 2.81426 5.36789 2.81426H10.6322C10.6322 2.81426 10.7368 2.83064 10.8669 2.74461ZM3.82084 1.9447L2.41966 1.94569C1.82341 1.94569 1.35132 2.39041 1.35132 2.95073L1.35132 17.7224C1.35132 18.2827 1.8233 18.7275 2.41955 18.7275H13.5805C14.1767 18.7275 14.6487 18.2827 14.6487 17.7224L14.6487 2.95073C14.6487 2.39041 14.1767 1.94569 13.5804 1.94569H12.1793V2.55308C12.1793 3.35429 11.4814 4.01271 10.6322 4.01271H5.36789C4.51869 4.01271 3.82084 3.35429 3.82084 2.55308V1.9447Z"
        fill={fill}
      />
      <path
        d="M9.06738 8.70587C9.06738 8.37718 9.32777 8.05843 9.71548 8.05843H12.2317C12.6194 8.05843 12.8798 8.37718 12.8798 8.70587V11.3436C12.8798 11.6723 12.6194 11.991 12.2317 11.991C11.844 11.991 11.5836 11.6723 11.5836 11.3436V10.3242L9.21828 12.8057C8.99121 13.0437 8.68043 13.1816 8.34416 13.1816C8.00789 13.1816 7.69719 13.0438 7.47012 12.8058L6.05612 11.3235L4.23797 13.2283C4.11368 13.3602 3.94283 13.4298 3.76813 13.4298C3.59139 13.4298 3.42279 13.3588 3.29897 13.229C3.06076 12.9793 3.06076 12.5854 3.29897 12.3357L5.18147 10.361C5.40855 10.123 5.71931 9.98516 6.05557 9.98516C6.39184 9.98516 6.70254 10.1229 6.92961 10.361L8.34249 11.8432L10.7186 9.35331H9.71548C9.32777 9.35331 9.06738 9.03456 9.06738 8.70587Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'clipboard-assessment';
